/**
 * Returns a display name from first/last name fields, falling back to
 * displayName. Mirrors the Strava "First Last" convention.
 *
 * `fallback` is used when none of the name fields are populated.
 * Defaults to "Rider" for public-facing contexts; admin contexts that
 * already have the user's email (e.g. dashboard rosters) typically pass
 * `profile.email` instead.
 */
export function getProfileName(
  profile: {
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
  },
  fallback = 'Rider',
): string {
  if (profile.firstName && profile.lastName) {
    return `${profile.firstName} ${profile.lastName}`;
  }
  if (profile.firstName) return profile.firstName;
  if (profile.displayName) return profile.displayName;
  return fallback;
}
